// 环境配置 - 改为 'local'、'test'、'testv2' 或 'prod' 快速切换
const ENVIRONMENT = 'prod';

// 区域/站点配置 - 改为 'cn'（国内）、'global'（国外）或 'uk'（英国站）快速切换
// 该常量即“按站点构建”的开关；注意 UK 站仅有 prod 环境（无测试环境）
export const REGION = 'global';

// 主聊天 API 地址配置
const CHAT_API_CONFIG = {
  local: 'http://192.168.112.24:8081/ai-agent', // 本地开发环境
  test: 'https://apiai-deven.elehear.cn',          // 测试环境
  testv2: 'https://apiai-deven.elehear.cn',        // 测试环境 v2（聊天无 v2，复用 test 地址）
  prod: {
    global: 'https://aiagent-v2.aihear.io',      // 正式环境 - 国外
    cn:     'https://aiagent-v2.aihear.cn',       // 正式环境 - 国内（待填写）
    uk:     'https://apikf-uk.aihear.io',         // 正式环境 - 英国站
  },
};

export const API_URL = (() => {
  const cfg = CHAT_API_CONFIG[ENVIRONMENT];
  return typeof cfg === 'object' ? cfg[REGION] : cfg;
})();

// 反馈 / App 后端接口 API 配置
export const FEEDBACK_API_CONFIG = {
  local: 'https://api-test.aihear.io',  // 本地开发环境复用 test 地址
  test:  'https://api-test.aihear.io',
  testv2: 'https://api-testv2.aihear.io',      // 测试环境 v2 - App 后端
  prod: {
    global: 'https://api-prod.aihear.io',        // 正式环境 - 国外
    cn:     'https://api.elehear.cn',         // 正式环境 - 国内
    uk:     'https://apiuk.aihear.io',         // 正式环境 - 英国站（App 后端）
  },
};

export const isProd = ENVIRONMENT === 'prod';

export const getAppBackendUrl = () => {
  const cfg = FEEDBACK_API_CONFIG[ENVIRONMENT];
  return typeof cfg === 'object' ? cfg[REGION] : cfg;
};

// 站点功能开关（UI 差异化）：通过 REGION 切换不同站点的 UI / 功能
// global、cn 保持原有行为；uk 隐藏反馈、底部菜单，显示顶部 Email Us 横条（网页顶栏保留，承载历史会话入口）
// 顶栏/历史页相关开关说明：
// - showChatClose：对话页右上角是否显示 ×（native Close）。UK 不显示（由 native 处理整体关闭）。
// - historyHasBack：历史页是否显示左上角 Back（点击返回对话页）。UK 不显示。
// - historyCloseExitsApp：历史页右上角 × 的行为。true=关闭整个 webview(native Close)；false=仅关闭历史页返回对话。
// - supportEmail：客服邮箱，Email Us 入口（顶部按钮、AI 回答里的邮箱链接兜底）作为参数传给原生
const FEATURES_BY_REGION = {
  global: { showFeedback: true,  showBottomMenu: true,  showWebTopBar: true,  showEmailUs: false, showChatClose: true,  historyHasBack: true,  historyCloseExitsApp: true,  supportEmail: 'support@elehear.com' },
  cn:     { showFeedback: true,  showBottomMenu: true,  showWebTopBar: true,  showEmailUs: false, showChatClose: true,  historyHasBack: true,  historyCloseExitsApp: true,  supportEmail: 'support@elehear.com' },
  uk:     { showFeedback: false, showBottomMenu: false, showWebTopBar: true,  showEmailUs: true,  showChatClose: false, historyHasBack: false, historyCloseExitsApp: false, supportEmail: 'support.uk@elehear.com' },
};

export const FEATURES = FEATURES_BY_REGION[REGION] || FEATURES_BY_REGION.global;
